import MerchantNameAndAvatar from '../../../MerchantNameAndAvatar';

interface IMerchant {
  id: string;
  name: string;
  logoUrl?: string | null;
}

interface IMerchantPrimaryElementProps {
  merchant?: IMerchant | null;
  fallbackDescription: string;
  secondaryText?: string;
}

const MerchantPrimaryElement = ({ merchant, fallbackDescription, secondaryText }: IMerchantPrimaryElementProps) => {
  return (
    <MerchantNameAndAvatar
      merchant={merchant}
      fallbackDescription={fallbackDescription}
      secondaryText={secondaryText}
    />
  );
};

export default MerchantPrimaryElement;
